/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { GoogleFontsIndexResponse } from '../types/GoogleFontsIndex'

/**
 * GET /google-fonts
 * @see backend/nexus/modules/System/Http/Controllers/GoogleFontsController.php GoogleFontsController::index
 */
export async function googleFontsIndex(
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<GoogleFontsIndexResponse>> {
	return axiosInstance.get('/google-fonts', config)
}
